import { useAuthStore } from '../stores/authStore';
import { ROLES } from '../lib/permissions';

export function TopBar() {
  const role = useAuthStore((s) => s.role);
  const toggleTheme = useAuthStore((s) => s.toggleTheme);
  const theme = useAuthStore((s) => s.theme);
  const learningMode = useAuthStore((s) => s.learningMode);
  const setLearningMode = useAuthStore((s) => s.setLearningMode);
  const config = ROLES[role];

  return (
    <div className="hidden lg:flex flex-shrink-0 bg-[var(--bg-primary)] border-b border-[var(--border-default)] h-14 px-4 items-center justify-between z-[100]">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <svg width="28" height="28" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" rx="8" fill="var(--status-positive)" />
            <path d="M6 22V8l4 7 5-9 5 9 4-7v14" stroke="#FFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="text-lg font-bold text-[var(--text-primary)]">
            MANGA<sup className="text-[11px] font-semibold text-[var(--text-tertiary)]">v1</sup>
          </span>
        </div>
        <span className="text-sm text-[var(--text-tertiary)] font-medium">
          Hacienda Los Llanos
        </span>
      </div>

      <div className="flex items-center gap-3">
        {/* Learning mode */}
        <div className="flex items-center gap-2">
          <span className="text-xs text-[var(--text-tertiary)] font-medium">
            Modo Aprendizaje
          </span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={learningMode}
              onChange={(e) => setLearningMode(e.target.checked)}
            />
            <div className="toggle-track" />
          </label>
        </div>

        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className="w-9 h-9 rounded-full bg-[var(--bg-secondary)] border border-[var(--border-default)] text-[var(--text-secondary)] flex items-center justify-center cursor-pointer transition-colors hover:bg-[var(--bg-tertiary)]"
          aria-label="Cambiar modo"
        >
          {theme === 'dark' ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="5" /><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>
          )}
        </button>

        {/* Avatar */}
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-bold cursor-pointer"
          style={{ background: config.color }}
        >
          {config.letter}
        </div>
      </div>
    </div>
  );
}
